import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotRecommendSection from './components/HotRecommendSection';
import LatestUpdateSection from './components/LatestUpdateSection';
import FeatureSection from './components/FeatureSection';
import FAQSection from './components/FAQSection';
import { faqs, categories } from '@/mocks/home';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蜜桃在线',
  url: 'https://peachshow.github.io',
  description: '蜜桃在线是您发现优质高清视频内容的首选平台，海量资源持续更新，流畅播放体验，支持多终端访问。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://peachshow.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '蜜桃在线',
  url: 'https://peachshow.github.io',
  description: '蜜桃在线是国内领先的高清视频内容平台。',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '蜜桃在线',
      item: 'https://peachshow.github.io',
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

        <HeroSection />
        <CategorySection />
        <HotRecommendSection />
        <LatestUpdateSection />
        <FeatureSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}